import React, { Component } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Divider,
  List,
  ListItem,
  Paper,
  Container,
  Dialog,
  DialogTitle,
  ListItemText,
  ListItemIcon,
  DialogActions,
} from "@mui/material";
import {
  Close as CloseIcon,
  ChevronRight as ChevronRightIcon,
  Storefront as StoreIcon,
  ConfirmationNumberOutlined as CouponIcon,
  DirectionsBike as DeliveryIcon,
  DirectionsWalk as PickupIcon,
} from "@mui/icons-material";
import { CartContext } from "../../comp/CartContext";
import { useNavigate, useParams } from "react-router-dom";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import MopedIcon from "@mui/icons-material/Moped";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

class Sacola extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);

    this.state = {
      openModal: false,
      metodoEntrega: localStorage.getItem("deliveryType") || "delivery",
      carrinho: [],
      Address: [],
      clear: false,
      loader: true
    };
  }

  componentDidMount() {
    fetch("/api/store/cart", {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status === 200) {
        response.json().then((data) => {
          this.setState({ carrinho: data.cart || [], Address: data.address || [], loader: false });
        });
      } else {
        this.setState({ loader: false });
      }
    }).catch(err => {
      console.error(err);
      this.setState({ loader: false });
    });
  }

  handleToggleModal = () => {
    this.setState({ openModal: !this.state.openModal });
  };

  selecionarMetodo = (metodo) => {
    if (metodo === "delivery") {
      if (this.state.Address.length === 0) {
        this.props.navigate("/address/new");
      } else {
        this.props.navigate("/address");
      }
    } else {
      this.setState({ metodoEntrega: metodo, openModal: false });
    }
  };

  Entrega(address) {
    if (!address || address.length === 0) {
      return <>Definir Endereço de Entrega</>;
    }
    const enderecoPadrao = address.find((item) => item.default === 1);

    if (!enderecoPadrao) {
      return <>Selecionar Endereço Padrão</>;
    } else {
      return (
        <>{enderecoPadrao.street}, {enderecoPadrao.house_number} - {enderecoPadrao.district}, {enderecoPadrao.city} - {enderecoPadrao.state}</>
      );
    }
  }

  render() {
    const { limparCarrinho, removerDoCarrinho } = this.context;
    const { carrinho, Address, loader } = this.state;

    const total = carrinho.reduce((acc, item) => {
      const precoBase = parseFloat(item.preco_unitario_momento) || 0;

      // Soma os adicionais se existirem
      const totalAdicionais = (item.opcoes || []).reduce(
        (soma, opt) => soma + (parseFloat(opt.preco_adicional) || 0),
        0
      );

      return acc + (precoBase + totalAdicionais) * item.quantidade;
    }, 0);

    const methods = {
      delivery: {
        icon: <MopedIcon sx={{ color: "#777", mr: 2 }} />,
        label: this.Entrega(Address),
      },
      takeout: {
        icon: <PickupIcon sx={{ color: "#777", mr: 2 }} />,
        label: "Retirar no local",
      },
      onsite: {
        icon: <StoreIcon sx={{ color: "#777", mr: 2 }} />,
        label: "Consumir no local",
      },
    };

    if (loader) {
      return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          {/* Loader / Spinner */}
        </Box>
      );
    }

    return (
      <Container
        maxWidth="sm"
        sx={{
          p: 0,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          bgcolor: "#fff",
        }}
      >
        {/* HEADER FIXO NO TOPO */}
        <Box
          sx={{
            top: 0,
            bgcolor: "#fff",
            zIndex: 10,
            p: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px dashed #ddd",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "1.1rem",
              color: "#263238",
              lineHeight: 1,
            }}
          >
            {this.context?.data?.name || "Carrinho"}
          </Typography>

          <IconButton onClick={() => window.history.back()} sx={{ p: 0.5 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* CONTEÚDO SCROLLABLE (MEIO) */}
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          {/* Botão Método de Entrega */}
          <Box
            onClick={this.handleToggleModal}
            sx={{
              display: "flex",
              alignItems: "center",
              p: 2,
              cursor: "pointer",
              borderBottom: "1px dashed #ddd",
            }}
          >
            {methods[this.state.metodoEntrega]?.icon}
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {methods[this.state.metodoEntrega]?.label}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {this.state.metodoEntrega !== "delivery" &&
                  this.context?.data?.address &&
                  `${this.context.data.address.rua}, ${this.context.data.address.numero} - ${this.context.data.address.bairro}, ${this.context.data.address.cidade} - ${this.context.data.estado || ""}`}
              </Typography>
            </Box>
            <ChevronRightIcon sx={{ color: this.context?.data?.color || "#1976d2" }} />
          </Box>

          {/* Lista de Itens */}
          <Box sx={{ p: 2 }}>
            {carrinho.length > 0 ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Sua sacola
                  </Typography>
                  <Button
                    size="small"
                    onClick={() => {
                      this.setState({ clear: true });
                    }}
                    sx={{ color: "#555", fontWeight: "bold" }}
                  >
                    LIMPAR
                  </Button>
                </Box>
                {carrinho.map((item) => {
                  const precoUnitario = parseFloat(item.preco_unitario_momento) || 0;
                  const precoTotalItem = precoUnitario * item.quantidade;

                  return (
                    <Paper
                      variant="outlined"
                      key={item.id}
                      sx={{
                        p: 2,
                        mb: 2,
                        borderRadius: 2.5,
                        borderColor: "#e0e0e0",
                        bgcolor: "#fafafa",
                      }}
                    >
                      {/* TÍTULO DO PRODUTO E PREÇO TOTAL DO ITEM */}
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1a1a1a", lineHeight: 1.2 }}>
                          {item.quantidade}x {item.nome_momento}
                        </Typography>

                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#1a1a1a", ml: 1 }}>
                          {precoTotalItem.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                        </Typography>
                      </Box>

                      {/* DISCRIMINAÇÃO DETALHADA DAS OPÇÕES / ADICIONAIS (CDC) */}
                      {item.opcoes && item.opcoes.length > 0 && (
                        <Box
                          sx={{


                            display: "flex",
                            flexDirection: "column",
                            gap: 0.5,
                          }}
                        >
                          {item.opcoes.map((opcao) => {
                            const precoAdicional = parseFloat(opcao.preco_adicional) || 0;

                            return (
                              <Box
                                key={opcao.id || `${opcao.option_group_id}-${opcao.option_item_id}`}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  fontSize: "0.85rem",
                                }}
                              >
                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.85rem" }}>
                                  <strong style={{ color: "#444" }}>{opcao.grupo_nome}:</strong> {opcao.item_nome}
                                </Typography>

                                {precoAdicional > 0 ? (
                                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#2e7d32", ml: 1 }}>
                                    +{precoAdicional.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                  </Typography>
                                ) : (
                                  <Typography variant="caption" color="text.disabled" sx={{ ml: 1 }}>
                                    Incluso
                                  </Typography>
                                )}
                              </Box>
                            );
                          })}
                        </Box>
                      )}

                      {/* OBSERVAÇÃO DO CONSUMIDOR */}
                      {item.observacao && (
                        <Box
                          sx={{
                            mt: 1,
                            p: 1,
                            bgcolor: "#fff",
                            borderRadius: 1,
                            border: "1px dashed #ccc",
                          }}
                        >
                          <Typography variant="caption" sx={{ color: "#555", fontStyle: "italic", display: "block" }}>
                            <strong>Obs:</strong> {item.observacao}
                          </Typography>
                        </Box>
                      )}

                      <Divider sx={{ my: 1.5 }} />

                      {/* RODAPÉ DO CARD COM AÇÕES (EDITAR / REMOVER E VALOR UNITÁRIO) */}
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Button
                            size="small"
                            sx={{
                              color: this.context?.data?.color || "#1976d2",
                              fontWeight: 700,
                              minWidth: 0,
                              p: 0,
                              textTransform: "none",
                            }}
                            onClick={() => {
                              this.props.navigate(`/produto/${item.produto_uuid}`);
                            }}
                          >
                            Editar
                          </Button>

                          <Button
                            size="small"
                            sx={{
                              color: "#d32f2f",
                              fontWeight: 600,
                              minWidth: 0,
                              p: 0,
                              textTransform: "none",
                            }}
                            onClick={() => {
                              fetch(`/api/store/cart/remove/${item.id}`, {
                                method: "DELETE",
                                headers: {
                                  "Content-Type": "application/json",
                                },
                              }).then((resp) => {
                                if (resp.status === 200) {
                                  this.context.removerDoCarrinho(item.produto_uuid);
                                  this.setState(({ carrinho }) => ({
                                    carrinho: carrinho.filter((i) => i.id !== item.id),
                                  }));
                                }
                              });
                            }}
                          >
                            Remover
                          </Button>
                        </Box>

                        {/* INFORMAÇÃO TRANSPARENTE DO VALOR UNITÁRIO */}
                        <Typography variant="caption" color="text.secondary">
                          Unitário: {precoUnitario.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                        </Typography>
                      </Box>
                    </Paper>
                  );
                })}
              </>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50vh",
                }}
              >
                <div>
                  <ShoppingBagIcon sx={{ fontSize: 100, color: this.context?.data?.color || "#9ca3af" }} />
                  <div style={{ color: "#282828", textAlign: "center" }}>Sacola vazia</div>
                </div>
              </Box>
            )}

            <Button
              fullWidth
              sx={{ color: this.context?.data?.color || "#1976d2", fontWeight: "bold", mt: 1 }}
              onClick={() => {
                this.props.navigate("/");
              }}
            >
              ADICIONAR MAIS ITENS
            </Button>
          </Box>
        </Box>

        {/* FOOTER FIXO NA BASE */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            bgcolor: "#fff",
            borderTop: "1px dashed #ccc",
            p: 2,
          }}
        >
          {carrinho.length > 0 && (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                <Typography color="textSecondary">Subtotal</Typography>
                <Typography color="textSecondary">
                  {total.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  Total
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {total.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                </Typography>
              </Box>
            </>
          )}

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
              cursor: "pointer",
            }}
          >
            <CouponIcon sx={{ color: "#777", mr: 1 }} />
            <Typography variant="body2" sx={{ flexGrow: 1, fontWeight: "bold" }}>
              Tem um cupom?
            </Typography>
            <ChevronRightIcon sx={{ color: this.context?.data?.color || "#1976d2" }} />
          </Box>

          <Button
            variant="contained"
            fullWidth
            disabled={carrinho.length === 0}
            endIcon={<ArrowRightAltIcon size={24} />}
            sx={{
              bgcolor: this.context?.data?.color || "#1976d2",
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              textTransform: "none",
              fontSize: "1.1rem",
            }}
            onClick={() => {
              this.props.navigate("/checkout");
            }}
          >
            Continuar Pedido
          </Button>
        </Box>

        {/* MODAL DE OPÇÕES DE RECEBIMENTO */}
        <Dialog
          open={this.state.openModal}
          onClose={this.handleToggleModal}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
            Como você quer receber o pedido?
          </DialogTitle>

          <List>
            {this.context?.data?.delivery?.entregaLocal === 1 && (
              <ListItem button onClick={() => this.selecionarMetodo("delivery")}>
                <ListItemIcon>
                  <MopedIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Entrega Local"
                  secondary="A gente leva até você"
                />
              </ListItem>
            )}

            {this.context?.data?.delivery?.retiradaLocal === 1 && (
              <ListItem button onClick={() => this.selecionarMetodo("takeout")}>
                <ListItemIcon>
                  <PickupIcon />
                </ListItemIcon>
                <ListItemText
                  primary="Retirada no Local"
                  secondary="Você retira no local"
                />
              </ListItem>
            )}
          </List>
        </Dialog>

        {/* MODAL DE LIMPAR CARRINHO */}
        <Dialog
          open={this.state.clear}
          onClose={() => { this.setState({ clear: false }); }}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle sx={{ fontWeight: "bold", fontSize: "1.1rem" }}>
            Tem certeza que deseja limpar seu carrinho?
          </DialogTitle>

          <DialogActions>
            <Button onClick={() => { this.setState({ clear: false }); }}>Cancelar</Button>
            <Button onClick={() => {
              fetch(`/api/store/cart/clean`, {
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json'
                },
              }).then((resp) => {
                if (resp.status === 200) {
                  limparCarrinho();
                  this.setState({
                    carrinho: [],
                    clear: false
                  });
                }
              });
            }}>Sim, limpar</Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }
}

function withRouter(Component) {
  return (props) => {
    const params = useParams();
    const navigate = useNavigate();
    return <Component {...props} params={params} navigate={navigate} />;
  };
}

export default withRouter(Sacola);